// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/payment_link.proto

/* eslint-disable */
import { ApiCurrencyAmount } from "../../../../common/payment";
import { ApiPaymentMethod, apiPaymentMethodFromJSON, apiPaymentMethodToJSON } from "./payment_method";

/** Enum for payment link status */
export const ApiPaymentLinkStatus = {
  /** PAYMENT_LINK_STATUS_UNSPECIFIED - Default unspecified value for unknown or unrecognized status */
  PAYMENT_LINK_STATUS_UNSPECIFIED: "PAYMENT_LINK_STATUS_UNSPECIFIED",
  /** PAYMENT_LINK_STATUS_OPEN - Payment link is open for payments */
  PAYMENT_LINK_STATUS_OPEN: "PAYMENT_LINK_STATUS_OPEN",
  /** PAYMENT_LINK_STATUS_PROCESSING - Payment link is processing */
  PAYMENT_LINK_STATUS_PROCESSING: "PAYMENT_LINK_STATUS_PROCESSING",
  /** PAYMENT_LINK_STATUS_PAID - Payment link has been paid */
  PAYMENT_LINK_STATUS_PAID: "PAYMENT_LINK_STATUS_PAID",
  /** PAYMENT_LINK_STATUS_EXPIRED - Payment link has expired */
  PAYMENT_LINK_STATUS_EXPIRED: "PAYMENT_LINK_STATUS_EXPIRED",
  /** PAYMENT_LINK_STATUS_CANCELED - Payment link has been canceled */
  PAYMENT_LINK_STATUS_CANCELED: "PAYMENT_LINK_STATUS_CANCELED",
} as const;

export type ApiPaymentLinkStatus = typeof ApiPaymentLinkStatus[keyof typeof ApiPaymentLinkStatus];

export namespace ApiPaymentLinkStatus {
  export type PAYMENT_LINK_STATUS_UNSPECIFIED = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
  export type PAYMENT_LINK_STATUS_OPEN = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_OPEN;
  export type PAYMENT_LINK_STATUS_PROCESSING = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PROCESSING;
  export type PAYMENT_LINK_STATUS_PAID = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PAID;
  export type PAYMENT_LINK_STATUS_EXPIRED = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_EXPIRED;
  export type PAYMENT_LINK_STATUS_CANCELED = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_CANCELED;
}

export function apiPaymentLinkStatusFromJSON(object: any): ApiPaymentLinkStatus {
  switch (object) {
    case 0:
    case "PAYMENT_LINK_STATUS_UNSPECIFIED":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
    case 1:
    case "PAYMENT_LINK_STATUS_OPEN":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_OPEN;
    case 2:
    case "PAYMENT_LINK_STATUS_PROCESSING":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PROCESSING;
    case 3:
    case "PAYMENT_LINK_STATUS_PAID":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PAID;
    case 4:
    case "PAYMENT_LINK_STATUS_EXPIRED":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_EXPIRED;
    case 5:
    case "PAYMENT_LINK_STATUS_CANCELED":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_CANCELED;
    default:
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
  }
}

export function apiPaymentLinkStatusToJSON(object: ApiPaymentLinkStatus): string {
  switch (object) {
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED:
      return "PAYMENT_LINK_STATUS_UNSPECIFIED";
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_OPEN:
      return "PAYMENT_LINK_STATUS_OPEN";
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PROCESSING:
      return "PAYMENT_LINK_STATUS_PROCESSING";
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PAID:
      return "PAYMENT_LINK_STATUS_PAID";
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_EXPIRED:
      return "PAYMENT_LINK_STATUS_EXPIRED";
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_CANCELED:
      return "PAYMENT_LINK_STATUS_CANCELED";
    default:
      return "PAYMENT_LINK_STATUS_UNSPECIFIED";
  }
}

/** Enum for resource type */
export const ApiResourceType = {
  /** RESOURCE_TYPE_UNSPECIFIED - Default unspecified value for unknown or unrecognized resource type */
  RESOURCE_TYPE_UNSPECIFIED: "RESOURCE_TYPE_UNSPECIFIED",
  /** RESOURCE_TYPE_BASKET - Basket resource type */
  RESOURCE_TYPE_BASKET: "RESOURCE_TYPE_BASKET",
  /** RESOURCE_TYPE_INVOICE - Invoice resource type */
  RESOURCE_TYPE_INVOICE: "RESOURCE_TYPE_INVOICE",
} as const;

export type ApiResourceType = typeof ApiResourceType[keyof typeof ApiResourceType];

export namespace ApiResourceType {
  export type RESOURCE_TYPE_UNSPECIFIED = typeof ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
  export type RESOURCE_TYPE_BASKET = typeof ApiResourceType.RESOURCE_TYPE_BASKET;
  export type RESOURCE_TYPE_INVOICE = typeof ApiResourceType.RESOURCE_TYPE_INVOICE;
}

export function apiResourceTypeFromJSON(object: any): ApiResourceType {
  switch (object) {
    case 0:
    case "RESOURCE_TYPE_UNSPECIFIED":
      return ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
    case 1:
    case "RESOURCE_TYPE_BASKET":
      return ApiResourceType.RESOURCE_TYPE_BASKET;
    case 2:
    case "RESOURCE_TYPE_INVOICE":
      return ApiResourceType.RESOURCE_TYPE_INVOICE;
    default:
      return ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
  }
}

export function apiResourceTypeToJSON(object: ApiResourceType): string {
  switch (object) {
    case ApiResourceType.RESOURCE_TYPE_UNSPECIFIED:
      return "RESOURCE_TYPE_UNSPECIFIED";
    case ApiResourceType.RESOURCE_TYPE_BASKET:
      return "RESOURCE_TYPE_BASKET";
    case ApiResourceType.RESOURCE_TYPE_INVOICE:
      return "RESOURCE_TYPE_INVOICE";
    default:
      return "RESOURCE_TYPE_UNSPECIFIED";
  }
}

/** Enum for Payment Link recurrence type */
export const ApiPaymentLinkRecurrenceType = {
  /** PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED - Default unspecified value for unknown or unrecognized payment link recurrence type */
  PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED: "PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED",
  /** PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF - One-off payment link recurrence type */
  PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF: "PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF",
  /** PAYMENT_LINK_RECURRENCE_TYPE_RECURRING - Recurring payment link recurrence type */
  PAYMENT_LINK_RECURRENCE_TYPE_RECURRING: "PAYMENT_LINK_RECURRENCE_TYPE_RECURRING",
} as const;

export type ApiPaymentLinkRecurrenceType =
  typeof ApiPaymentLinkRecurrenceType[keyof typeof ApiPaymentLinkRecurrenceType];

export namespace ApiPaymentLinkRecurrenceType {
  export type PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED =
    typeof ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED;
  export type PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF =
    typeof ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF;
  export type PAYMENT_LINK_RECURRENCE_TYPE_RECURRING =
    typeof ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_RECURRING;
}

export function apiPaymentLinkRecurrenceTypeFromJSON(object: any): ApiPaymentLinkRecurrenceType {
  switch (object) {
    case 0:
    case "PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED":
      return ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED;
    case 1:
    case "PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF":
      return ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF;
    case 2:
    case "PAYMENT_LINK_RECURRENCE_TYPE_RECURRING":
      return ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_RECURRING;
    default:
      return ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED;
  }
}

export function apiPaymentLinkRecurrenceTypeToJSON(object: ApiPaymentLinkRecurrenceType): string {
  switch (object) {
    case ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED:
      return "PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED";
    case ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF:
      return "PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF";
    case ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_RECURRING:
      return "PAYMENT_LINK_RECURRENCE_TYPE_RECURRING";
    default:
      return "PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED";
  }
}

/** Enum for item type */
export const ApiItemType = {
  /** ITEM_TYPE_UNSPECIFIED - Default unspecified value for unknown or unrecognized item type */
  ITEM_TYPE_UNSPECIFIED: "ITEM_TYPE_UNSPECIFIED",
  /** ITEM_TYPE_GOOD - Good item type */
  ITEM_TYPE_GOOD: "ITEM_TYPE_GOOD",
  /** ITEM_TYPE_SERVICE - Service item type */
  ITEM_TYPE_SERVICE: "ITEM_TYPE_SERVICE",
} as const;

export type ApiItemType = typeof ApiItemType[keyof typeof ApiItemType];

export namespace ApiItemType {
  export type ITEM_TYPE_UNSPECIFIED = typeof ApiItemType.ITEM_TYPE_UNSPECIFIED;
  export type ITEM_TYPE_GOOD = typeof ApiItemType.ITEM_TYPE_GOOD;
  export type ITEM_TYPE_SERVICE = typeof ApiItemType.ITEM_TYPE_SERVICE;
}

export function apiItemTypeFromJSON(object: any): ApiItemType {
  switch (object) {
    case 0:
    case "ITEM_TYPE_UNSPECIFIED":
      return ApiItemType.ITEM_TYPE_UNSPECIFIED;
    case 1:
    case "ITEM_TYPE_GOOD":
      return ApiItemType.ITEM_TYPE_GOOD;
    case 2:
    case "ITEM_TYPE_SERVICE":
      return ApiItemType.ITEM_TYPE_SERVICE;
    default:
      return ApiItemType.ITEM_TYPE_UNSPECIFIED;
  }
}

export function apiItemTypeToJSON(object: ApiItemType): string {
  switch (object) {
    case ApiItemType.ITEM_TYPE_UNSPECIFIED:
      return "ITEM_TYPE_UNSPECIFIED";
    case ApiItemType.ITEM_TYPE_GOOD:
      return "ITEM_TYPE_GOOD";
    case ApiItemType.ITEM_TYPE_SERVICE:
      return "ITEM_TYPE_SERVICE";
    default:
      return "ITEM_TYPE_UNSPECIFIED";
  }
}

/** Enum for subscription recurrency */
export const ApiFrequencyRecurrence = {
  /** FREQUENCY_RECURRENCE_UNSPECIFIED - Default unspecified value for unknown or unrecognized frequency */
  FREQUENCY_RECURRENCE_UNSPECIFIED: "FREQUENCY_RECURRENCE_UNSPECIFIED",
  /** FREQUENCY_RECURRENCE_WEEKLY - weekly frequency */
  FREQUENCY_RECURRENCE_WEEKLY: "FREQUENCY_RECURRENCE_WEEKLY",
  /** FREQUENCY_RECURRENCE_MONTHLY - monthly frequency */
  FREQUENCY_RECURRENCE_MONTHLY: "FREQUENCY_RECURRENCE_MONTHLY",
  /** FREQUENCY_RECURRENCE_QUARTERLY - quarterly frequency */
  FREQUENCY_RECURRENCE_QUARTERLY: "FREQUENCY_RECURRENCE_QUARTERLY",
  /** FREQUENCY_RECURRENCE_SEMESTERLY - semesterly frequency */
  FREQUENCY_RECURRENCE_SEMESTERLY: "FREQUENCY_RECURRENCE_SEMESTERLY",
  /** FREQUENCY_RECURRENCE_YEARLY - yearly frequency */
  FREQUENCY_RECURRENCE_YEARLY: "FREQUENCY_RECURRENCE_YEARLY",
} as const;

export type ApiFrequencyRecurrence = typeof ApiFrequencyRecurrence[keyof typeof ApiFrequencyRecurrence];

export namespace ApiFrequencyRecurrence {
  export type FREQUENCY_RECURRENCE_UNSPECIFIED = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED;
  export type FREQUENCY_RECURRENCE_WEEKLY = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_WEEKLY;
  export type FREQUENCY_RECURRENCE_MONTHLY = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_MONTHLY;
  export type FREQUENCY_RECURRENCE_QUARTERLY = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_QUARTERLY;
  export type FREQUENCY_RECURRENCE_SEMESTERLY = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_SEMESTERLY;
  export type FREQUENCY_RECURRENCE_YEARLY = typeof ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_YEARLY;
}

export function apiFrequencyRecurrenceFromJSON(object: any): ApiFrequencyRecurrence {
  switch (object) {
    case 0:
    case "FREQUENCY_RECURRENCE_UNSPECIFIED":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED;
    case 1:
    case "FREQUENCY_RECURRENCE_WEEKLY":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_WEEKLY;
    case 2:
    case "FREQUENCY_RECURRENCE_MONTHLY":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_MONTHLY;
    case 3:
    case "FREQUENCY_RECURRENCE_QUARTERLY":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_QUARTERLY;
    case 4:
    case "FREQUENCY_RECURRENCE_SEMESTERLY":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_SEMESTERLY;
    case 5:
    case "FREQUENCY_RECURRENCE_YEARLY":
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_YEARLY;
    default:
      return ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED;
  }
}

export function apiFrequencyRecurrenceToJSON(object: ApiFrequencyRecurrence): string {
  switch (object) {
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED:
      return "FREQUENCY_RECURRENCE_UNSPECIFIED";
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_WEEKLY:
      return "FREQUENCY_RECURRENCE_WEEKLY";
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_MONTHLY:
      return "FREQUENCY_RECURRENCE_MONTHLY";
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_QUARTERLY:
      return "FREQUENCY_RECURRENCE_QUARTERLY";
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_SEMESTERLY:
      return "FREQUENCY_RECURRENCE_SEMESTERLY";
    case ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_YEARLY:
      return "FREQUENCY_RECURRENCE_YEARLY";
    default:
      return "FREQUENCY_RECURRENCE_UNSPECIFIED";
  }
}

/** Message for payment initiator information */
export interface ApiPaymentInitiator {
  /** Resource ID */
  readonly resourceId: string;
  /** Resource type */
  readonly resourceType: ApiResourceType;
  /** Resource number (can be null) */
  readonly resourceNumber?: string | null | undefined;
}

/** Message for payment link settings */
export interface ApiPaymentLinkSettings {
  /** URL to redirect to after payment */
  readonly redirectUrl?:
    | string
    | null
    | undefined;
  /** How many number of payments/subscriptions can be done out of a payment link. If not provided: reusable payment link */
  readonly limit?: number | null | undefined;
}

/** Message for recurrence settings */
export interface ApiRecurrenceSettings {
  /** Frequency recurrence - required when payment link type is recurring */
  readonly frequencyRecurrence: ApiFrequencyRecurrence;
  /** Frequency value - required when payment link type is recurring, min=1 */
  readonly frequencyValue: number;
  /** Total number of payments for the subscription - optional, min=1, max=9999 */
  readonly times?: number | null | undefined;
}

/** Message for payment link item */
export interface ApiPaymentLinkItem {
  /** Item ID */
  readonly id?:
    | string
    | null
    | undefined;
  /** Item title */
  readonly title: string;
  /** Item type */
  readonly type?:
    | ApiItemType
    | null
    | undefined;
  /** Item description */
  readonly description?:
    | string
    | null
    | undefined;
  /** Item quantity */
  readonly quantity: number;
  /** Measurement unit */
  readonly measureUnit?:
    | string
    | null
    | undefined;
  /** Unit price */
  readonly unitPrice:
    | ApiCurrencyAmount
    | null;
  /** VAT rate */
  readonly vatRate: string;
}

/** Message for payment link */
export interface ApiPaymentLink {
  /** Unique identifier of the payment link */
  readonly id: string;
  /** Payment amount */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** Latest payment method used (can be null) */
  readonly latestPaymentMethod?:
    | ApiPaymentMethod
    | null
    | undefined;
  /** Debitor name (can be null) */
  readonly debitorName?:
    | string
    | null
    | undefined;
  /** Payment initiator information */
  readonly paymentInitiator:
    | ApiPaymentInitiator
    | null;
  /** Payment link status */
  readonly status: ApiPaymentLinkStatus;
  /** List of potential payment methods */
  readonly potentialPaymentMethods: readonly ApiPaymentMethod[];
  /** Payment link settings (can be null) */
  readonly settings?:
    | ApiPaymentLinkSettings
    | null
    | undefined;
  /** Expiration date */
  readonly expirationDate?:
    | string
    | null
    | undefined;
  /** Organization name (can be null) */
  readonly organizationName?:
    | string
    | null
    | undefined;
  /** Payment link name */
  readonly name: string;
  /** Creation timestamp */
  readonly createdAt: string;
  /** Payment link items */
  readonly items: readonly ApiPaymentLinkItem[];
  /** Recurrence settings (required when it is a recurrent payment link) */
  readonly recurrenceSettings?:
    | ApiRecurrenceSettings
    | null
    | undefined;
  /** Payment link recurrence type */
  readonly recurrenceType: ApiPaymentLinkRecurrenceType;
}

export const ApiPaymentInitiator: MessageFns<ApiPaymentInitiator> = {
  fromJSON(object: any): ApiPaymentInitiator {
    return {
      resourceId: isSet(object.resource_id) ? globalThis.String(object.resource_id) : "",
      resourceType: isSet(object.resource_type)
        ? apiResourceTypeFromJSON(object.resource_type)
        : ApiResourceType.RESOURCE_TYPE_UNSPECIFIED,
      resourceNumber: isSet(object.resource_number) ? globalThis.String(object.resource_number) : null,
    };
  },

  toJSON(message: ApiPaymentInitiator): unknown {
    const obj: any = {};
    if (message.resourceId !== undefined && message.resourceId !== null) {
      obj.resource_id = message.resourceId;
    }
    if (message.resourceType !== undefined && message.resourceType !== null) {
      obj.resource_type = apiResourceTypeToJSON(message.resourceType);
    }
    if (message.resourceNumber !== undefined && message.resourceNumber !== null) {
      obj.resource_number = message.resourceNumber;
    }
    return obj;
  },
};

export const ApiPaymentLinkSettings: MessageFns<ApiPaymentLinkSettings> = {
  fromJSON(object: any): ApiPaymentLinkSettings {
    return {
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : null,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : null,
    };
  },

  toJSON(message: ApiPaymentLinkSettings): unknown {
    const obj: any = {};
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.limit !== undefined && message.limit !== null) {
      obj.limit = Math.round(message.limit);
    }
    return obj;
  },
};

export const ApiRecurrenceSettings: MessageFns<ApiRecurrenceSettings> = {
  fromJSON(object: any): ApiRecurrenceSettings {
    return {
      frequencyRecurrence: isSet(object.frequency_recurrence)
        ? apiFrequencyRecurrenceFromJSON(object.frequency_recurrence)
        : ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED,
      frequencyValue: isSet(object.frequency_value) ? globalThis.Number(object.frequency_value) : 0,
      times: isSet(object.times) ? globalThis.Number(object.times) : null,
    };
  },

  toJSON(message: ApiRecurrenceSettings): unknown {
    const obj: any = {};
    if (message.frequencyRecurrence !== undefined && message.frequencyRecurrence !== null) {
      obj.frequency_recurrence = apiFrequencyRecurrenceToJSON(message.frequencyRecurrence);
    }
    if (message.frequencyValue !== undefined && message.frequencyValue !== null) {
      obj.frequency_value = Math.round(message.frequencyValue);
    }
    if (message.times !== undefined && message.times !== null) {
      obj.times = Math.round(message.times);
    }
    return obj;
  },
};

export const ApiPaymentLinkItem: MessageFns<ApiPaymentLinkItem> = {
  fromJSON(object: any): ApiPaymentLinkItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : null,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? apiItemTypeFromJSON(object.type) : null,
      description: isSet(object.description) ? globalThis.String(object.description) : null,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      measureUnit: isSet(object.measure_unit) ? globalThis.String(object.measure_unit) : null,
      unitPrice: isSet(object.unit_price) ? ApiCurrencyAmount.fromJSON(object.unit_price) : null,
      vatRate: isSet(object.vat_rate) ? globalThis.String(object.vat_rate) : "",
    };
  },

  toJSON(message: ApiPaymentLinkItem): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.title !== undefined && message.title !== null) {
      obj.title = message.title;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = apiItemTypeToJSON(message.type);
    }
    if (message.description !== undefined && message.description !== null) {
      obj.description = message.description;
    }
    if (message.quantity !== undefined && message.quantity !== null) {
      obj.quantity = message.quantity;
    }
    if (message.measureUnit !== undefined && message.measureUnit !== null) {
      obj.measure_unit = message.measureUnit;
    }
    if (message.unitPrice !== undefined && message.unitPrice !== null) {
      obj.unit_price = ApiCurrencyAmount.toJSON(message.unitPrice);
    }
    if (message.vatRate !== undefined && message.vatRate !== null) {
      obj.vat_rate = message.vatRate;
    }
    return obj;
  },
};

export const ApiPaymentLink: MessageFns<ApiPaymentLink> = {
  fromJSON(object: any): ApiPaymentLink {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      latestPaymentMethod: isSet(object.latest_payment_method)
        ? apiPaymentMethodFromJSON(object.latest_payment_method)
        : null,
      debitorName: isSet(object.debitor_name) ? globalThis.String(object.debitor_name) : null,
      paymentInitiator: isSet(object.payment_initiator) ? ApiPaymentInitiator.fromJSON(object.payment_initiator) : null,
      status: isSet(object.status)
        ? apiPaymentLinkStatusFromJSON(object.status)
        : ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED,
      potentialPaymentMethods: globalThis.Array.isArray(object?.potential_payment_methods)
        ? object.potential_payment_methods.map((e: any) => apiPaymentMethodFromJSON(e))
        : [],
      settings: isSet(object.settings) ? ApiPaymentLinkSettings.fromJSON(object.settings) : null,
      expirationDate: isSet(object.expiration_date) ? globalThis.String(object.expiration_date) : null,
      organizationName: isSet(object.organization_name) ? globalThis.String(object.organization_name) : null,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdAt: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ApiPaymentLinkItem.fromJSON(e))
        : [],
      recurrenceSettings: isSet(object.recurrence_settings)
        ? ApiRecurrenceSettings.fromJSON(object.recurrence_settings)
        : null,
      recurrenceType: isSet(object.recurrence_type)
        ? apiPaymentLinkRecurrenceTypeFromJSON(object.recurrence_type)
        : ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED,
    };
  },

  toJSON(message: ApiPaymentLink): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.latestPaymentMethod !== undefined && message.latestPaymentMethod !== null) {
      obj.latest_payment_method = apiPaymentMethodToJSON(message.latestPaymentMethod);
    }
    if (message.debitorName !== undefined && message.debitorName !== null) {
      obj.debitor_name = message.debitorName;
    }
    if (message.paymentInitiator !== undefined && message.paymentInitiator !== null) {
      obj.payment_initiator = ApiPaymentInitiator.toJSON(message.paymentInitiator);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiPaymentLinkStatusToJSON(message.status);
    }
    if (message.potentialPaymentMethods?.length) {
      obj.potential_payment_methods = message.potentialPaymentMethods.map((e) => apiPaymentMethodToJSON(e));
    }
    if (message.settings !== undefined && message.settings !== null) {
      obj.settings = ApiPaymentLinkSettings.toJSON(message.settings);
    }
    if (message.expirationDate !== undefined && message.expirationDate !== null) {
      obj.expiration_date = message.expirationDate;
    }
    if (message.organizationName !== undefined && message.organizationName !== null) {
      obj.organization_name = message.organizationName;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.created_at = message.createdAt;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ApiPaymentLinkItem.toJSON(e));
    }
    if (message.recurrenceSettings !== undefined && message.recurrenceSettings !== null) {
      obj.recurrence_settings = ApiRecurrenceSettings.toJSON(message.recurrenceSettings);
    }
    if (message.recurrenceType !== undefined && message.recurrenceType !== null) {
      obj.recurrence_type = apiPaymentLinkRecurrenceTypeToJSON(message.recurrenceType);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
